import React from 'react';
import PropTypes from 'prop-types';

import InfoRegionBlock from './AirlinesInfoRegionBlock';
import { flightsAndAirlines as strings } from 'core/i18n';

const AirlinesRowDetails = ({
  advanceCheckIn,
  name,
  checkInOptions,
  checkInTime,
  delayedBaggage,
  logo,
  lostNfound,
  website,
}) => {
  return (
    <div className="list__item__details">
      <div className="airline__info-region airline__check-in-info">
        {checkInOptions && (
          <InfoRegionBlock label={strings.checkIn} html={checkInOptions} />
        )}
      </div>
      <div className="airline__info-region airline__check-in-detail">
        {checkInTime && (
          <InfoRegionBlock label={strings.checkInTime} html={checkInTime} />
        )}
        {advanceCheckIn && (
          <InfoRegionBlock label={strings.preCheckIn} html={advanceCheckIn} />
        )}
      </div>
      <div className="airline__info-region airline__baggage-info">
        {delayedBaggage && (
          <InfoRegionBlock
            label={strings.delayedBaggage}
            html={delayedBaggage}
          />
        )}
        {lostNfound && (
          <InfoRegionBlock
            label={strings.foundPropertyInformation}
            html={lostNfound}
          />
        )}
      </div>
      <div className="airline__info-region airline__airline-info">
        {website && <InfoRegionBlock label={strings.website} html={website} />}
        {logo && (
          <div className="airline__info-region__block__content">
            <img src={logo} alt={`${name} logo`} className="airline__logo" />
          </div>
        )}
      </div>
    </div>
  );
};

AirlinesRowDetails.propTypes = {
  advanceCheckIn: PropTypes.string.isRequired,
  checkInOptions: PropTypes.string.isRequired,
  checkInTime: PropTypes.string.isRequired,
  delayedBaggage: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  lostNfound: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default AirlinesRowDetails;
